import React from 'react';
import { useTranslation } from 'react-i18next';
import {
	GovAccordion,
	GovLayout,
	GovLayoutColumn,
} from '@gov-design-system-ce/react';
import type { CmsFaqListItem } from '@gov-nx/api';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { AccordionItem, LayoutGap, SectionHeader } from '@gov-nx/ui/web';
import { MarkdownRender } from '../Markdown/MarkdownRender';

export interface CmsFaqProps {
	faq: CmsFaqListItem[];
	localizeNameSpace?: LocalizeNameSpaceTypes;
}

export const CmsFaq = ({
	faq,
	localizeNameSpace = LocalizeNameSpaceTypes.Page,
}: CmsFaqProps) => {
	const { t } = useTranslation([localizeNameSpace]);
	return (
		<section
			aria-labelledby="titulek-casto-se-ptate"
			className="w-full">
			<LayoutGap gap="l">
				<SectionHeader
					id="titulek-casto-se-ptate"
					headline={t('casto-se-ptate', {
						namespace: localizeNameSpace,
					})}
				/>
				<GovLayout
					type="text"
					variant="left">
					<GovLayoutColumn>
						<GovAccordion size="m">
							{faq.map((accordion) => (
								<AccordionItem
									size="m"
									key={accordion.id}
									label={<h3>{accordion.question}</h3>}>
									<MarkdownRender>{accordion.answer}</MarkdownRender>
								</AccordionItem>
							))}
						</GovAccordion>
					</GovLayoutColumn>
				</GovLayout>
			</LayoutGap>
		</section>
	);
};
